import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import couterpart from 'counterpart';
import { withRouter } from 'react-router-dom'
import {ToastsContainer, ToastsStore} from 'react-toasts';

import AuthenticationService from '../services/AuthenticationService';
import MenuComponent2 from './MenuComponent2';
// import ReactTablePagination from './PaginationComponent';
import ShopDataService from '../services/ShopDataService';
import "../css/style.css";

import {MdDeleteForever, MdModeEdit} from 'react-icons/md';
import {IoIosAddCircleOutline} from 'react-icons/io';
import { ICON_COLOR } from '../icon';

class ShopList extends Component {
  constructor () {
    super();
    
    const shop_id = couterpart.translate('shop_id');
    const shop_name = couterpart.translate('shop_name');
    const shop_description = couterpart.translate('shop_description');
    const shop_pcode = couterpart.translate('shop_pcode');
    const shop_action = couterpart.translate('shop_action');

    this.state = {
      shops: [],
      columns : [{
          Header: shop_id,
          accessor: 'id'
        },{
            Header: shop_name,
            accessor: 'name'
        },{
            Header: shop_description,
            accessor: 'description'
        },{
            Header: shop_pcode,
            accessor: 'pcode',  
            width: 150,
            style: {
              cursor: "pointer",
              color: "black"
            }, 
        },{
            Header: couterpart.translate('shop_pre'),
            accessor: 'pre'                                        
        },{
            Header: shop_action,
            accessor: 'action',
            width: 150,
            Cell: row =>(
              this.getFunctionButtons(row)
            )
      }]
    };
  }
  
  getFunctionButtons(row){
      if (AuthenticationService.isAdmin()){
        const button_edit = couterpart.translate('button_edit');
        const button_delete = couterpart.translate('button_delete');
        return (
          <div style={{ textAlign: "center" }}>
          <button className="myButton" onClick={() => this.handleEdit(row.original)}>
          <MdModeEdit color={ICON_COLOR}/>&nbsp;
          {button_edit}</button>&nbsp;
          <button className="myButton" onClick={() => this.handleDelete(row.original)}>
          <MdDeleteForever color={ICON_COLOR}/>&nbsp;
          {button_delete}</button>
        </div>
        )
      }else{
        return (<div>&nbsp;</div>)
      }
  }

  componentDidMount () {
    ShopDataService.retrieveShops().then(data => {
      if (data.message === undefined){
        this.setState({ shops:  data})
      }else{
        this.setState({ shops:  []})
        ToastsStore.error(data.message);
      }
    });
  }

  handleEdit(e){
    this.setState({action: 'EDIT'}, () =>{
      this.props.history.push("/shops/edit/" + e.id);
    });
  }

  handleDelete(e){
    ShopDataService.delete(e.id).then(data => {
      if (data.message === undefined){
        ShopDataService.retrieveShops().then(data => {
          this.setState({ shops:  data})
        });
      }
    });
  }  

  handleChangeStatus(e){
    this.setState({action: 'ADD'}, () =>{
      this.props.history.push("/shops/add");
    });
  }

  render() {
    if (!AuthenticationService.isAdmin()){
      return (<div>Unauthorized access.</div>);
    }
    const button_add = couterpart.translate('button_add');
    return (
          <div>
              <MenuComponent2/>
              <ToastsContainer store={ToastsStore} position="bottom_center" />
              <div style={{padding:"5px"}}>
              <button name="Add" className="myButton" 
                onClick={this.handleChangeStatus.bind(this)}>
                <IoIosAddCircleOutline color={ICON_COLOR}/>&nbsp;
                {button_add}</button></div>
              <ReactTable
                NoDataComponent={() => null} 
                // PaginationComponent={ReactTablePagination}
                previousText={"<"}
                nextText={">"}
                data={this.state.shops}
                columns={this.state.columns}
                defaultPageSize = {10}
                showPageSizeOptions = {true}
                pageSizeOptions = {[3, 5, 10, 20]}
                getTrProps={(state, rowInfo, column) => { 
                  if (rowInfo && rowInfo.row) {
                  return {
                    onClick: (e) => {
                      this.setState({
                        selected: rowInfo.index,
                        itemId: rowInfo.original.id
                      })
                    },
                    style: {
                      background: rowInfo.index === this.state.selected ? '#DCDCDC' : 'white',
                      color: rowInfo.index === this.state.selected ? 'white' : 'black'
                    }
                  }
                  }else{
                    return {}
                  }
                }
              }
              />
          </div>      
    )
  }
}

export default withRouter(ShopList);